import { render, staticRenderFns } from "./SplitTransactionDetailModal.vue?vue&type=template&id=05d878af&scoped=true"
import script from "./SplitTransactionDetailModal.vue?vue&type=script&lang=js"
export * from "./SplitTransactionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SplitTransactionDetailModal.vue?vue&type=style&index=0&id=05d878af&lang=css"
import style1 from "./SplitTransactionDetailModal.vue?vue&type=style&index=1&id=05d878af&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d878af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d878af')) {
      api.createRecord('05d878af', component.options)
    } else {
      api.reload('05d878af', component.options)
    }
    module.hot.accept("./SplitTransactionDetailModal.vue?vue&type=template&id=05d878af&scoped=true", function () {
      api.rerender('05d878af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/SplitTransactionDetailModal.vue"
export default component.exports